import Waterfall from './src/main.js';

export default Waterfall;



// WEBPACK FOOTER //
// ./packages/waterfall/index.js